var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBaixa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 39,
    viewBox: "0 0 44 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2658 19.1348L43.1289 25.3115L36.9253 26.2016",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71045 8.21143L22.4684 17.5439L26.2715 13.0125L43.1292 25.312",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35962 30.1397V14.0371",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2415 30.1397V15.6016",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1504 30.1398V20.6455",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0322 30.1403V20.5381",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9409 30.1398V25.2578",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3607 27.9548C35.064 28.6021 34.9292 28.764 34.5516 29.3574C30.9912 35.0216 24.41 38.4741 17.2893 37.7458C7.30949 36.6939 0.0809051 27.766 1.10585 17.7862C2.1308 7.80635 11.0856 0.577726 21.0654 1.60268C28.9143 2.41186 35.064 8.10305 36.8172 15.3587C36.8981 15.6553 36.9521 15.9251 37.006 16.2218",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBaixa);
export default __webpack_public_path__ + "static/media/icon_baixa.b7d3f6fc3b96a29449f01dd812ae44ce.svg";
export { ForwardRef as ReactComponent };